import { render, staticRenderFns } from "./SucPeriodComponent.vue?vue&type=template&id=2f002ae0&scoped=true&"
import script from "./SucPeriodComponent.vue?vue&type=script&lang=js&"
export * from "./SucPeriodComponent.vue?vue&type=script&lang=js&"
import style0 from "./SucPeriodComponent.vue?vue&type=style&index=0&id=2f002ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f002ae0",
  null
  
)

export default component.exports